<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <img src="@/assets/img/logo.png" alt="Vuetify.js" class="mb-5" />
        <v-flex class="headline">
          First, solve the problem. Then, write the code.
          <footer class="subheading">
            <em>John Johnson</em>
          </footer>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>
<script>
import ParametrosAPI from "@/services/generales/parametros";

export default {
  name: "FeedsPage"
  , data() {
    return {
      view: {
        title: "Inicio"
        , action: { getNews: { busy: false } }
        , message: { noMoreResults: { visible: false } }
        , button: { showMore: { visible: false } }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , mounted() {
    this.loadParametros();
  }
  , methods: {
    async loadParametros() {
      await ParametrosAPI.get({ clave: 1 });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Feeds.vue